import _extends from "@babel/runtime/helpers/extends";
import React from 'react';
import { SearchResultContent } from './search-result-content';
import { SearchResultLink } from './search-result-link';
import { EnlargedSearchResultContent } from './search-result-content-enlarged';
/**
 * This component provides a legacy method of rendering search results. It is
 * a composition of SearchResultLink and SearchResultContent.
 */
export var SearchResult = function SearchResult(props) {
  var ResultContentComponent = props.isQuickFind ? EnlargedSearchResultContent : SearchResultContent;
  return /*#__PURE__*/React.createElement(SearchResultLink, props, function (isKeyboardHighlighted) {
    return /*#__PURE__*/React.createElement(ResultContentComponent, _extends({}, props, {
      isKeyboardHighlighted: isKeyboardHighlighted
    }));
  });
};